/**
 * Configuração de ambiente do frontend.
 *
 * Em desenvolvimento a base da API é relativa (`/api`) e o Vite faz o proxy
 * para o backend PHP. Em produção o frontend é servido em
 * https://faturamento.sisprecisa.com.br e a API em .../api — o valor vem de
 * `VITE_API_URL` (ver `.env.production`), com fallback para `/api`, que também
 * funciona por ser mesma origem.
 */

const rawBase = import.meta.env.VITE_API_URL ?? '/api'

/** Base da API sem barra final (ex.: `https://.../api` ou `/api`). */
export const API_BASE_URL = String(rawBase).replace(/\/+$/, '')

/** true quando o bundle foi gerado com `vite build`. */
export const IS_PRODUCTION = import.meta.env.PROD

export const APP_ENV = import.meta.env.MODE

export const config = { API_BASE_URL, IS_PRODUCTION, APP_ENV }

export default config
